import Reveal from '../../../shared/Reveal/Reveal';
import './LiveCalendar.css';

const WIDGET_CONFIG = {
  colorTheme: 'light',
  isTransparent: true,
  width: '100%',
  height: '100%',
  locale: 'en',
  importanceFilter: '-1,0,1',
};

const calendarSrcDoc = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html,
      body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: #ffffff;
      }

      .tradingview-widget-container,
      .tradingview-widget-container__widget {
        width: 100%;
        height: 100%;
      }
    </style>
  </head>
  <body>
    <div class="tradingview-widget-container">
      <div class="tradingview-widget-container__widget"></div>
      <script type="text/javascript" src="https://s3.tradingview.com/external-embedding/embed-widget-events.js" async>
        ${JSON.stringify(WIDGET_CONFIG)}
      </script>
    </div>
  </body>
</html>`;

const LiveCalendar = () => {
  return (
    <section className="live-calendar">
      <div className="live-calendar__inner">
        <Reveal className="live-calendar__header">
          <div className="live-calendar__heading">
            <p className="live-calendar__eyebrow">Live Calendar</p>
            <h2 className="live-calendar__title">Real-Time Events &amp; Releases.</h2>
          </div>

          <p className="live-calendar__lead">
            Use filters to focus on the economies, event types, and impact levels
            most relevant to your strategy.
          </p>
        </Reveal>

        <Reveal className="live-calendar__panel" delay={80}>
          <div className="live-calendar__widget-shell">
            <iframe
              className="live-calendar__frame"
              title="TradingView Live Economic Calendar"
              srcDoc={calendarSrcDoc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default LiveCalendar;
